import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import  { Auth } from 'aws-amplify';

import { redirectToLogIn } from '../../util/util';
import './Sidebar.css';

class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state={
            logout: false
        }
    }

    logout = () => {
        Auth.signOut();
        // this.setState({
        //     logout: true
        // });
    }

    handleLoginClick = () => {
        redirectToLogIn();
    }

    render() {
        // if(this.state.logout){
        //     return <Redirect to="/logout" />
        // }
        return (
            <nav id="sidebar" className="side-nav">
                <ul className="list-unstyled components">
                    {!Object.keys(this.props.user).length ? 
                        <li><button onClick={this.handleLoginClick}><span className="caption">Login</span></button></li>
                        :
                        <li className="nameLi"><button><span className="caption">{this.props.user.name}</span></button></li>
                    }                   
                    <li><Link to="/rules"><span className="caption">Rules</span></Link></li>
                    <li><Link to="/processing"><span className="caption">File Processing</span></Link></li>
                     {!Object.keys(this.props.user).length || 
                        <li className="logout"><button onClick={this.logout}><span className="caption">Logout</span></button></li>
                    }
                </ul>
            </nav>
        );
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js